export type OrderedTechnicianDisplayName = {
  technicianUserGuid: string
  technicianDisplayName?: string | null
}

const normalizeTechnicianDisplayName = (technicianDisplayName?: string | null): string | undefined => {
  const normalizedName = technicianDisplayName?.trim()
  return normalizedName ? normalizedName : undefined
}

export const getOrderedUniqueTechnicianDisplayNames = (
  technicians: readonly OrderedTechnicianDisplayName[],
): string[] => {
  const seenTechnicianUserGuids = new Set<string>()

  return technicians.flatMap(technician => {
    if (seenTechnicianUserGuids.has(technician.technicianUserGuid)) {
      return []
    }

    seenTechnicianUserGuids.add(technician.technicianUserGuid)

    const technicianDisplayName = normalizeTechnicianDisplayName(technician.technicianDisplayName)
    return technicianDisplayName ? [technicianDisplayName] : []
  })
}

export const formatTechnicianDisclosure = (orderedTechnicianDisplayNames: readonly string[]): string | undefined => {
  if (orderedTechnicianDisplayNames.length === 0) {
    return undefined
  }

  if (orderedTechnicianDisplayNames.length === 1) {
    return orderedTechnicianDisplayNames[0]
  }

  return `${orderedTechnicianDisplayNames[0]} + ${orderedTechnicianDisplayNames.length - 1} more`
}
